import type { RouteLocationNormalized, NavigationGuardNext, Router } from 'vue-router'

// 明確列舉所有 layout，避免 Vite 動態字串導入在 production build 無法靜態分析的問題
const layouts = {
  LayoutDefault: () => import('@/layouts/LayoutDefault.vue'),
  LayoutBlank: () => import('@/layouts/LayoutBlank.vue')
}

/**
 * 路由 layout 守衛，根據路由的 `meta.layout` 動態載入對應的 layout 元件。
 *
 * 載入後將元件掛載至 `to.meta.layoutComponent`，由 `App.vue` 的動態 `<component :is>` 渲染。
 * 未指定 `meta.layout` 時預設使用 `LayoutDefault`（含側欄與頁首的標準版型）。
 * 載入失敗時僅 console 記錄，不阻斷導航（降級為無 layout）。
 */
export const layoutMiddleware = async ({
  to,
  from,
  next
}: {
  to: RouteLocationNormalized
  from: RouteLocationNormalized
  next: NavigationGuardNext
}) => {
  const layout = to.meta.layout || 'LayoutDefault'

  // 動態載入 layout 元件並掛載至 route meta，供 App.vue 使用
  try {
    const layoutLoader = layouts[layout as keyof typeof layouts]
    if (layoutLoader) {
      const layoutComponent = await layoutLoader()
      to.meta.layoutComponent = layoutComponent.default
    }
  } catch (error) {
    console.log('layoutComponent error', error)
  }

  next()
}
